import { utcDateTime } from './utc-date-time';

export const getUTCAfternoon = (utcDate: string): string => {
  return utcDateTime(utcDate).startOf('day').set({ hour: 12 }).toISO({
    suppressMilliseconds: true,
  });
};
